import { ActivatedRouteSnapshot } from '@angular/router';

import { submissionDocumentTypesTokenizer } from '../store';
import { CONFIGURE_DEFAULT_PARAMS } from '../constants';

export const submissionDocumentTypesResolver = (
  activatedRouteSnapshot: ActivatedRouteSnapshot,
) => {
  const _submissionDocumentTypesTokenizer = submissionDocumentTypesTokenizer();
  const _params = CONFIGURE_DEFAULT_PARAMS(activatedRouteSnapshot);
  const _workspaceTypeId = activatedRouteSnapshot.paramMap.get(
    'workspaceTypeId',
  ) as string;
  const _entityType = activatedRouteSnapshot.paramMap.get(
    'entityType',
  ) as string;

  _submissionDocumentTypesTokenizer.loadAllDocumentTypes(_entityType);
  _submissionDocumentTypesTokenizer.loadAllAttributes(_params);

  _submissionDocumentTypesTokenizer.loadSubmissionDocumentTypes(
    _entityType,
    _workspaceTypeId,
  );
  return !!_submissionDocumentTypesTokenizer.$data();
};
